// @flow


import 'fonts/roboto/roboto.css'
import 'fonts/gotham/gotham.css'
import 'fonts/montserrat/montserrat.css'

import React from 'react'
import Helmet from 'react-helmet'
import { I18nProvider } from '@lingui/react'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import withStyles from 'material-ui/styles/withStyles'
import CssBaseline from 'material-ui/CssBaseline'

import Header from 'components/Header'
import theme from 'styles/theme'

type Props = {
  children: Function,
  data: any,
}

const extractCatalogs = ({ translations }) => {
  return translations.edges.reduce((obj, { node }) => {
    const { lang, key, value } = node
    if (!obj[lang]) obj[lang] = { messages: {} }
    obj[lang].messages[key] = value
    return obj
  }, {})
}

const Layout = ({ children, data }: Props) => (
  <I18nProvider language={'si'} catalogs={extractCatalogs(data)}>
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Helmet
        title={'Preset'}
        meta={[
          { name: 'description', content: 'Preset d.o.o.' },
          { name: 'keywords', content: 'website development' },
        ]}
      />
      <Header />
      {children()}
    </MuiThemeProvider>
  </I18nProvider>
)

const styles = () => ({
  '@global': {
    body: {
      margin: 0,
      overflowX: 'hidden',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
    },
    img: {
      display: 'inline-block',
      maxWidth: '100%',
    },
  },
})

export default withStyles(styles)(Layout)

declare var graphql: Function;

export const query = graphql`
  query LayoutQuery {
    translations: allPresetTranslation(filter: { lang: { eq: "si" } }) {
      edges {
        node {
          lang
          key
          value
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js